import config from "@/config/config";

const userHelper = {
	user: null,
	getUser: function() {
		// if( this.user === null ) {
			const userSession = localStorage.getItem('user');
			this.user = userSession ? JSON.parse(userSession) : null;
		// }
		return this.user;
	},
	getUserInfo: function(field, defaultVal) {
		const user = this.getUser();

		if( user && user[ field ] !== undefined ) {
			return user[ field ];
		}
		else {
			return defaultVal;
		}
	},
	getUserId: function() {
		return this.getUserInfo('userId', 0);
	},
	getProfilePicture: function() {
		return `${config.BASE_IMAGE_URL}${this.getUserInfo('profilePicture')}`;
	},
	isLogged: function() {
		return this.getUserId();
	}
}

export {
	userHelper
}
